export const builderRoutes = {
  path: 'builder',
  lazy: async () => {
    const { default: BuilderSession } = await import(
      '@/pages/dashboard/sessions/bots/builder'
    )

    return { Component: BuilderSession }
  },
}
